export enum TickerSymbol {
  EUA_DAILY = 'EUA_DAILY',
  UKA_DAILY = 'UKA_DAILY',
}

export const TickerCurrency: Record<keyof typeof TickerSymbol, 'EUR' | 'GBP' | 'USD'> = {
  EUA_DAILY: 'EUR',
  UKA_DAILY: 'GBP',
};
